/**
 * Member profile — sibling of picks/leaderboard/groups so the tab bar stays on the origin tab.
 * Mirrors app/app/worldcup/member-profile.tsx for the generic competition tree.
 */

import { useLocalSearchParams } from 'expo-router';
import { MemberProfileView } from '../../../../components/worldcup/MemberProfileView/MemberProfileView';

export default function CompetitionMemberProfileRoute() {
  const { groupId, memberId, wcTab, self, rank } = useLocalSearchParams<{
    groupId?: string;
    memberId: string;
    wcTab?: string;
    self?: string;
    rank?: string;
  }>();
  const parsedRank = rank ? Number(rank) : null;
  return (
    <MemberProfileView
      groupId={groupId ?? ''}
      memberId={memberId ?? ''}
      wcTab={wcTab}
      isSelf={self === '1'}
      rank={parsedRank != null && Number.isFinite(parsedRank) ? parsedRank : null}
    />
  );
}
